import Swiper, { Navigation } from 'swiper'

export default class Report {
  constructor() {
    this.slider = document.querySelector('.swiper--report')
    this.navigationPrev = document.querySelector('.slider-button-prev--report')
    this.navigationNext = document.querySelector('.slider-button-next--report')

    this.initSlider()
  }

  initSlider() {
    const swiper = new Swiper(this.slider, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 30,
      grabCursor: true,
      allowTouchMove: true,
      navigation: {
        nextEl: this.navigationNext,
        prevEl: this.navigationPrev,
      }
    })
  }

}
